import { withApollo } from '@apollo/client/react/hoc';
import { flow, map, range } from 'lodash-es';
import type { FC, ReactElement } from 'react';

import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

import withTranslate from 'common/i18n/i18n';
import { withPageStatus } from 'common/viewcomp/general/ci_pagestatus';

import './stepper.scss';

interface Props {
    t: Function;
    steps: number;
    activeStep: number;
}

const _CIStepper: FC<Props> = (props): ReactElement => {
    return (
        <div className="stepper-container" role="progressbar">
            <Stepper activeStep={props.activeStep - 1} alternativeLabel>
                {map(range(0, props.steps), (index) => (
                    <Step key={index}>
                        <StepLabel />
                    </Step>
                ))}
            </Stepper>
        </div>
    );
};

_CIStepper.defaultProps = {
    steps: 3,
};

const CIStepper = flow([withTranslate('user'), withPageStatus, withApollo])(_CIStepper);

export default CIStepper;
